import React, {useCallback, useEffect} from 'react';
import { useDispatch } from "react-redux";
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { authLogout } from "../../redux/reducers/appReducer";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const SignOut = (props) => {
  const { history } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const stableDispatch = useCallback(args => {
    return dispatch(args)
  }, [dispatch]);

  useEffect(() => {
    stableDispatch(authLogout(history));
  },[stableDispatch]);
  

  return (
    <div className={classes.root}>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <Typography variant="h1">
              Завершение работы
            </Typography>
            <Typography variant="subtitle2">
              Спасибо, до свидания...
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default SignOut;
